import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CustomSnackbarComponent } from 'src/app/shared/components/custom-snackbar/custom-snackbar.component';
import { BrowserStorageService } from 'src/app/shared/utils/browser-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private storage: BrowserStorageService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      request.url.includes('Auth/Login') ||
      request.url.includes('Auth/ForgotPassword') ||
      request.url.includes('Auth/TwoStepVerification') ||
      request.url.includes('Auth/EmailConfirmationByOTP') ||
      request.url.includes('SubscriptionPlan/GetAllSubscriptionPlan') ||
      request.url.includes('Subsciber/CreateSubscriber') ||
      request.url.includes('/Blog/GetAllBlogs') ||
      request.url.includes('Blog/GetBlog') ||
      request.url.includes('Auth/ResetPassword') ||
      request.url.includes('Subscriber/CreateSubscriber') ||
      request.url.includes('ContactUs/ContactUs') ||
      request.url.includes('Auth/TwoStepVerification') ||
      request.url.includes('Auth/ResendEmailConfirmation') ||
      request.url.includes('Auth/social-login') ||
      request.url.includes('/apple-login') ||
      request.url.includes('/Auth/DeleteAccount') ||
      request.url.includes('/Auth/Register') ||
      request.url.includes('Home/GetAddedTodayProperties') ||
      request.url.includes('Home/GetArisPrimeProperties') ||
      request.url.includes('Home/GetOpenHouseProperties') ||

      request.url.includes('Home/GetRecommendedProperties') ||

      request.url.includes('Property/Mls/') ||
      request.url.includes('Home/ContactUs') ||
      request.url.includes('Home/SubmitAgentApplication') ||
      request.url.includes('Home/GetAllAgents') ||
      request.url.includes('Home/GetAgentById') ||
      request.url.includes('Socials/Youtube/Videos') ||
      request.url.includes('Socials/Twitter/Tweets') ||
      request.url.includes('Home/CreateSubscriber') ||
      request.url.includes('Home/ContactAgent') ||
      request.url.includes('OffMarketProperties/Shared/') ||
      request.url.includes('Auth/CheckEmail') ||
      request.url.includes('MarketedProperty/SearchProperty') ||
      request.url.includes('MarketedProperty/map-markers') ||
      request.url.includes('MarketedProperty/Public/Listing') ||
      request.url.includes('Rental/SearchProperty') ||
      request.url.includes('Rental/map-markers') ||
      request.url.includes('Rental/Public/Listing')
    ) {
      return next.handle(request);
    } else {
      const token = this.storage.get('accessToken');
      if (!token) {
        if (!isPlatformBrowser(this.platformId)) {
          // SSR renders anonymously: forward the request without a token and
          // let the API respond 401 — never snackbar/redirect on the server.
          return next.handle(request);
        }
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: {
            title: `Authentication Failed, Please Login Again.`,
            type: 'danger',
          },
          panelClass: 'danger',
          duration: 5000,
          horizontalPosition: 'start',
        });
        this.router.navigate(['auth', 'signin']);
        return EMPTY;
      }
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + token),
      });
    }
    return next.handle(request);
  }
}
